import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
    energyportfolioendpoints: [],
    isGetEndpointLoading: false,
    isCreateEndpointLoading: false,
    isDeleteEndpointLoading: false,
};

export const apiGetEndpoints = createAsyncThunk(
    "endpoints/getEndpoint",
    async (data, thunkAPI) => {
        try {
            const response = await axios.get('/api/energyportfolio/get_endpoints');
            return { data: response.data, status: response.status, statusText: response.message }
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiEnergyportfolioCreateEndpoint = createAsyncThunk(
    "endpoints/createEndpoint",
    async (data, thunkAPI) => {
        try {
            const response = await axios.post('/api/energyportfolio/create_endpoint', data);
            return { data: response.data, status: response.status, statusText: response.message }
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiEnergyportfolioDeleteEndpoint = createAsyncThunk(
    "endpoints/apiDeleteEndpoint",
    async (uuid, thunkAPI) => {
        try {
            const response = await axios.post(`/api/energyportfolio/delete_endpoint?uuid=${uuid}`);
            return { data: response.data, status: response.status, statusText: response.statusText };
        } catch (error) {
            const err = error.response.data;
            return thunkAPI.rejectWithValue(err);
        }
    }
);

export const endpointSlice = createSlice({
    name: "endpoints",
    initialState,
    reducers: {
        deleteEndpoint: (state, action) => {
            state.endpoints = state.endpoints.filter((endpoint) => endpoint.uuid !== action.payload);
        }
    },
    extraReducers: (builder) => {
        // getEndpoints
        builder
            .addCase(apiGetEndpoints.pending, (state, action) => {
                state.isGetEndpointLoading = true;
            })
            .addCase(apiGetEndpoints.fulfilled, (state, action) => {
                state.isGetEndpointLoading = false;
                state.endpoints = action.payload.data;
            })
            .addCase(apiGetEndpoints.rejected, (state, action) => {
                state.isGetEndpointLoading = false;
            });

        // createEndpoint
        builder
            .addCase(apiEnergyportfolioCreateEndpoint.pending, (state, action) => {
                state.isCreateEndpointLoading = true;
            })
            .addCase(apiEnergyportfolioCreateEndpoint.fulfilled, (state, action) => {
                state.isCreateEndpointLoading = false;
            })
            .addCase(apiEnergyportfolioCreateEndpoint.rejected, (state, action) => {
                state.isCreateEndpointLoading = false;
            });

        // delete endpoint
        builder
            .addCase(apiEnergyportfolioDeleteEndpoint.pending, (state) => {
                state.isDeleteEndpointLoading = true;
            })
            .addCase(apiEnergyportfolioDeleteEndpoint.fulfilled, (state, action) => {
                state.isDeleteEndpointLoading = false;
            })
            .addCase(apiEnergyportfolioDeleteEndpoint.rejected, (state) => {
                state.isDeleteEndpointLoading = false;
            })
    }
});

export const { deleteEndpoint } = endpointSlice.actions;

export default endpointSlice.reducer;